import { Dialog, Text } from '../../../components';
import React from 'react';
import { T_ActionItems } from '@repo-sapiens/data-access-models';
import { css } from '@emotion/css';
import { theme } from '@repo-sapiens/theme';
import { format } from 'date-fns';

type Props = {
  item?: T_ActionItems;
  open?: boolean;
  onOpenChange?(open: boolean): void;
};
export const TaskDetailsDialog: React.FC<Props> = ({
  item,
  open,
  onOpenChange,
}) => {
  const getSourceLink = () => {
    switch (item?.sourceTool) {
      case 'email':
        return item.sourceToolId
          ? `https://mail.google.com/mail/u/0/#inbox/${item?.sourceToolId}`
          : undefined;
      case 'meeting':
        return item.sourceToolId
          ? `/transcript/${item.sourceToolId}?internal=yes`
          : undefined;
      default:
        return;
    }
  };

  const sourceLink = getSourceLink();
  const externalLink = sourceLink?.includes('https://');

  return (
    <Dialog
      noClose
      additionalContent={
        <div
          className={css`
            width: 100%;
            min-width: 500px;
          `}
        >
          <table
            className={css`
              border-collapse: collapse;
              width: 100%;
              margin-bottom: 16px;
              td {
                border-bottom: 1px solid ${theme.colors.border.primary};
                padding: 4px 0px;
              }
              tr {
                cursor: pointer;
              }
            `}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    maxWidth: 150,
                  }}
                >
                  <Text.BodyXS color="seconday">From</Text.BodyXS>
                </td>
                <td
                  style={{
                    paddingLeft: 12,
                  }}
                >
                  <Text.BodyXS>{item?.source}</Text.BodyXS>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    maxWidth: 150,
                  }}
                >
                  <Text.BodyXS color="seconday">Source email</Text.BodyXS>
                </td>
                <td
                  style={{
                    paddingLeft: 12,
                  }}
                >
                  <Text.BodyXS>{item?.sourceEmail}</Text.BodyXS>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    maxWidth: 150,
                  }}
                >
                  <Text.BodyXS color="seconday">Profile</Text.BodyXS>
                </td>
                <td
                  style={{
                    paddingLeft: 12,
                  }}
                >
                  <Text.BodyXS>{item?.subsource}</Text.BodyXS>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    maxWidth: 150,
                  }}
                >
                  <Text.BodyXS color="seconday">Task</Text.BodyXS>
                </td>
                <td
                  style={{
                    paddingLeft: 12,
                  }}
                >
                  <Text.BodyXS>{item?.task}</Text.BodyXS>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    maxWidth: 150,
                  }}
                >
                  <Text.BodyXS color="seconday">Priority</Text.BodyXS>
                </td>
                <td
                  style={{
                    paddingLeft: 12,
                  }}
                >
                  <Text.BodyXS>{item?.priority}</Text.BodyXS>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    maxWidth: 150,
                  }}
                >
                  <Text.BodyXS color="seconday">Scope</Text.BodyXS>
                </td>
                <td
                  style={{
                    paddingLeft: 12,
                  }}
                >
                  <Text.BodyXS>{item?.sourceScope}</Text.BodyXS>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    maxWidth: 150,
                  }}
                >
                  <Text.BodyXS color="seconday">Due date</Text.BodyXS>
                </td>
                <td
                  style={{
                    paddingLeft: 12,
                  }}
                >
                  <Text.BodyXS>
                    {item?.dueDate
                      ? format(new Date(item.dueDate), 'EEEE, MMMM do')
                      : 'Unspecified'}
                  </Text.BodyXS>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    maxWidth: 150,
                  }}
                >
                  <Text.BodyXS color="seconday">Tool</Text.BodyXS>
                </td>
                <td
                  style={{
                    paddingLeft: 12,
                  }}
                >
                  <Text.BodyXS>{item?.sourceTool}</Text.BodyXS>
                </td>
              </tr>
            </tbody>
          </table>
          <Text.Link
            size="body-sm"
            href={sourceLink}
            target={externalLink ? '_blank' : undefined}
            rel={externalLink ? 'noreferrer' : undefined}
            style={{ marginBottom: 16, marginTop: 16 }}
          >
            Go to the source
          </Text.Link>
        </div>
      }
      open={open}
      onOpenChange={onOpenChange}
    />
  );
};
